import React from "react";
import PropTypes from "prop-types";
import HotTable from "react-handsontable";
import axios from "axios";

import {
  colHeaders,
  columns,
  colWidths,
  correctBoolean,
  generateData
} from "./data";

function handlerErrors(data) {
  const errors = [];

  Object.keys(data).forEach(key => {
    if (data[key].name === "") {
      errors.push(key);
      delete data[key];
    }
  });

  if (errors.length > 0) {
    toastr.error("Name can't be blank.");
  }

  return data;
}

class LocationEditor extends React.Component {
  state = { locations: this.props.locations.map(item => correctBoolean(item)) };

  render() {
    const { locations } = this.state;

    return (
      <div>
        <h1>Locations Editor</h1>
        <div className="row">
          <div className="col-md-12">
            <div className="pull-right">
              <a
                className="btn btn-pink btn-raised btn-long margin-right-five"
                href="/locations_importer"
              >
                IMPORT
              </a>
              <a
                href='#'
                className="btn btn-indigo btn-raised btn-long margin-right-five"
                onClick={this.onExport}
              >
                EXPORT
              </a>
            </div>
          </div>
        </div>
        <br />
        <HotTable
          data={locations}
          rowHeaders={false}
          colWidths={colWidths}
          colHeaders={colHeaders}
          columns={columns}
          width={1200}
          height={(locations.length * 25) + 80}
          onAfterChange={this.onAfterChange}
          fixedColumnsLeft={2}
          afterInit={() => {
            setTimeout(() => {
              const hiddenTextarea = document.getElementById("HandsontableCopyPaste");
              if (hiddenTextarea) {
                hiddenTextarea.setAttribute("aria-hidden", "true");
              }
              document.querySelectorAll(".ht_master .wtHolder, .ht_clone_left .wtHolder, .ht_clone_top .wtHolder .current .ht_highlight").forEach((element) => {
                element.setAttribute("tabindex", "0");
                element.setAttribute("role", "region"); 
                element.setAttribute("aria-label", "Scrollable table section"); 
                element.style.outline = "none";
              });
            }, 0);
          }}
        />
      </div>
    );
  }

  onAfterChange = (changesArray, source) => {
    if ((changesArray && source === "edit") || source === "CopyPaste.paste") {
      let data = generateData(this.state.locations, changesArray);
      data = handlerErrors(data);
      if (Object.keys(data).length === 0) {
        return;
      }

      axios.put(`/locations.json`, { locations: data }).then(resp => {
        toastr.info(resp.data.message);
      });
    }
  };

  onExport = (e) => {
    e.preventDefault();
    axios
      .post("/locations/export.json")
      .then(() => {
        toastr.success('Your Location Export will be generated shortly, an email with a link will be sent and the file will be available in your My Downloads.');
      })
      .catch(() => {
        toastr.error("Unable to export Locations at this time.");
      });
  };
}



LocationEditor.propTypes = {
  locations: PropTypes.array
};

export default LocationEditor;
